import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = { width: "100%" }
const _hoisted_3 = {
  class: "has-text-weight-bold",
  style: {"background-color":"#f69522","color":"#ffffff"}
}
const _hoisted_4 = { width: "50%" }
const _hoisted_5 = {
  key: 0,
  style: {"padding":"8px","color":"white","background-color":"grey"}
}
const _hoisted_6 = {
  key: 1,
  style: {"padding":"8px","color":"white","background-color":"green"}
}
const _hoisted_7 = {
  key: 2,
  style: {"padding":"8px","color":"white","background-color":"red"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", {
      class: _normalizeClass({ 'has-text-white': _ctx.isDark })
    }, [
      _createElementVNode("strong", {
        class: _normalizeClass({ 'has-text-white': _ctx.isDark })
      }, _toDisplayString(_ctx.listing.product_id), 3)
    ], 2),
    _hoisted_1,
    _createElementVNode("table", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listing.reviews, (review) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: review.customer_id
        }, [
          _createElementVNode("td", _hoisted_3, _toDisplayString(review.nickname), 1),
          _createElementVNode("td", _hoisted_4, _toDisplayString(review.detail), 1),
          _createElementVNode("td", null, [
            (review.review_status == 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, " New "))
              : _createCommentVNode("", true),
            (review.review_status == 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, " Approved "))
              : _createCommentVNode("", true),
            (review.review_status == 2)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, " Rejected "))
              : _createCommentVNode("", true),
            _hoisted_8,
            _hoisted_9,
            (review.review_status != 1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  type: "button",
                  class: _normalizeClass(["button is-light", { 'is-primary': _ctx.isDark, 'is-info': !_ctx.isDark }]),
                  onClick: ($event: any) => (_ctx.approveReview({sku: _ctx.listing.sku, review_id: review.id}))
                }, " Approve ", 10, _hoisted_10))
              : _createCommentVNode("", true),
            (review.review_status != 2)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 4,
                  type: "button",
                  class: _normalizeClass(["button is-light", { 'is-primary': _ctx.isDark, 'is-info': !_ctx.isDark }]),
                  onClick: ($event: any) => (_ctx.rejectReview({sku: _ctx.listing.sku, review_id: review.id}))
                }, " Reject ", 10, _hoisted_11))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("td", null, _toDisplayString(review.id), 1)
        ]))
      }), 128))
    ])
  ], 64))
}